import { DocumentsStudyFolderDTO } from "../../dtos/documents-study-folder.dto";

export class GetDocumentCardRootFolderAction {
  static readonly type = '[DocumentCard] [GET] [Get Document Card Root Folder]';

  constructor(
    public organizationId: string,
    public studyId: string,
  ) {}
}

export class GetDocumentCardSubFolderAction {
  static readonly type = '[DocumentCard] [GET] [Get Document Card Sub Folder]';

  constructor(
    public organizationId: string,
    public studyId: string,
    public folderId: string,
  ) {}
}

export class CreateDocumentCardFolderAction {
  static readonly type = '[DocumentCard] [POST] [Create Folder]';
  constructor(
    public newFolder: DocumentsStudyFolderDTO,
  ) {}
}

export class UpdateDocumentCardFolderAction {
  static readonly type = '[DocumentCard] [POST] [Update Folder]';
  constructor(
    public updatedFolder: DocumentsStudyFolderDTO,
  ) {}
}

export class DeleteDocumentCardFolderAction {
  static readonly type = '[DocumentCard] [POST] [Delete Folder]';
  constructor(
    public folderToDelete: DocumentsStudyFolderDTO,
  ) {}
}

export class GetDocumentCardDetailsAction {
  static readonly type = '[DocumentCard] [GET] [Get Document Card Details]';
  constructor(
    public organizationId: string,
    public studyId: string,
    public folderId: string,
  ) {}
}

export class ResetDocumentCardFoldersAction {
  static readonly type = '[DocumentCard] Reset Folders';
}

export class ResetDocumentCardDetailsAction {
  static readonly type = '[DocumentCard] Reset Folder Details';
}

export class UpdateDocumentFolderAction {
  static readonly type = '[Documents] [POST] [Update Folder]';
  constructor(
    public organizationId: string,
    public studyId: string,
    public documentId: string,
    public versionNo: string,
    public folderId: string,
  ) {}
}